module.exports = {"222406001":"民慧街道","222406002":"光明街道","222406003":"文化街道","222406100":"八家子镇","222406101":"福洞镇","222406102":"头道镇","222406103":"西城镇","222406104":"南坪镇","222406105":"东城镇","222406106":"崇善镇","222406107":"龙城镇","222406400":"和龙林业局","222406401":"八家子林业局","222406402":"和龙市林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222406.json
// module id = 669
// module chunks = 0